import React from "react";
import IndividualScenarioAccessSection from "./IndividualScenarioAccessSection";
import { useInstitutionConfig } from "./InstitutionConfigContext";

export default function ScenarioAccessTab() {
  const { decodedInstitution } = useInstitutionConfig();

  return (
    <IndividualScenarioAccessSection institution={decodedInstitution} />
  );
}
